import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dodao-ui/dodao-ui/academy-ui/src/app/clickable-demos/view/[...demoId]/ViewClickableDemo.tsx");
